/**
 * @desc Yung-审批中回调事件
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/onEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
